import { formatUrl, TPersonalInformationFormData } from "@cpj-ai/panel-npm-package";
import {
  AuthAccountContactTypeChoices,
  ContactType,
  GetProfileQuery,
  UpdateProfileMutationVariables,
} from "@graphql/generated";

export const toGraphQLProfile = (formData: TPersonalInformationFormData): UpdateProfileMutationVariables => ({
  firstName: formData.firstName,
  lastName: formData.lastName,
  gender: typeof formData.gender === "string" ? formData.gender : formData.gender?.value,
  birthDate: formData.birthDate,
  city: formData.city?.node?.id,
  allowNotifications: formData.allowNotifications,
  contacts: [
    {
      type: AuthAccountContactTypeChoices.PHONE,
      value: formData.phone || "",
    },
    {
      type: AuthAccountContactTypeChoices.WHATSAPP,
      value: formData.whatsapp || "",
    },
    {
      type: AuthAccountContactTypeChoices.LINKEDIN,
      value: formatUrl(formData.linkedin || ""),
    },
    {
      type: AuthAccountContactTypeChoices.WEBSITE,
      value: formatUrl(formData.website || ""),
    },
    {
      type: AuthAccountContactTypeChoices.ADDRESS,
      value: formData.address || "",
    },
  ].filter((contact) => contact.value !== ""),
});

const getContactByType = (contacts: (ContactType | null)[] | null | undefined, type: AuthAccountContactTypeChoices) =>
  contacts?.find((item) => item?.type === type)?.value;

export const fromGraphQLProfile = (personalInformation: GetProfileQuery): TPersonalInformationFormData => ({
  firstName: personalInformation?.me?.firstName,
  lastName: personalInformation?.me?.lastName,
  gender: personalInformation?.me?.profile?.gender,
  birthDate: personalInformation?.me?.profile?.birthDate,
  country: personalInformation?.me?.profile?.city?.country,
  region: personalInformation?.me?.profile?.city?.region,
  city: { node: personalInformation?.me?.profile?.city || null },
  email: personalInformation?.me?.email,
  phone: getContactByType(personalInformation?.me?.profile?.contacts, AuthAccountContactTypeChoices.PHONE),
  whatsapp: getContactByType(personalInformation?.me?.profile?.contacts, AuthAccountContactTypeChoices.WHATSAPP),
  linkedin: getContactByType(personalInformation?.me?.profile?.contacts, AuthAccountContactTypeChoices.LINKEDIN),
  website: getContactByType(personalInformation?.me?.profile?.contacts, AuthAccountContactTypeChoices.WEBSITE),
  address: getContactByType(personalInformation?.me?.profile?.contacts, AuthAccountContactTypeChoices.ADDRESS),
  allowNotifications: personalInformation?.me?.profile?.allowNotifications,
});
